import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { AppLayout } from "./components/AppLayout";
import { FullScreenLoader } from "./components/FullScreenLoader";
import Login from "./pages/Login";
import FinishSignIn from "./pages/FinishSignIn";
import Tests from "./pages/Tests";
import Attempt from "./pages/Attempt";
import Review from "./pages/Review";
import Admin from "./pages/Admin";

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function RequireAdmin({ children }: { children: JSX.Element }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/tests" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/finish-signin" element={<FinishSignIn />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/tests" element={<Tests />} />
        <Route path="/tests/attempt/:attemptId" element={<Attempt />} />
        <Route path="/tests/review/:attemptId" element={<Review />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <Admin />
            </RequireAdmin>
          }
        />
      </Route>

      <Route path="/" element={<Navigate to="/tests" replace />} />
      <Route path="*" element={<Navigate to="/tests" replace />} />
    </Routes>
  );
}
